import User from "~/model/user";
import {
  GET_AUTH_USER,
  GET_AUTH_USER_OK,
  GET_AUTH_USER_ERR,
  LOGIN_USER,
  LOGIN_USER_OK,
  LOGIN_USER_ERR,
  SAVE_RETURN_URL,
  DO_LOGIN_USER_CLEANUP,
  LOGIN_WITH_AUTH0,
  LOGIN_WITH_AUTH0_OK,
  LOGIN_WITH_AUTH0_ERR,
  LOGOUT_USER,
  LOGOUT_USER_OK,
  LOGOUT_USER_ERR,
  REFRESH_AUTH_USER,
  REFRESH_AUTH_USER_OK,
  REFRESH_AUTH_USER_ERR,
  VALIDATE_VERIF_CODE,
  VALIDATE_VERIF_CODE_OK,
  VALIDATE_VERIF_CODE_ERR,
  RESEND_VERIF_CODE,
  RESEND_VERIF_CODE_OK,
  RESEND_VERIF_CODE_ERR,
  DO_VERIF_CODE_CLEANUP,
} from "./actionTypes"
import {
  GetUserResponse,
  LoginUserRequest,
  LoginUserResponse,
  ValidateVerifCodeRequest,
  ValidateVerifCodeResponse,
  ResendVerifCodeResponse,
 } from "~/types/backend";

export const getAuthUser = () => ({
  type: GET_AUTH_USER,
});

export const getAuthUserOk = (response: GetUserResponse) => ({
  type: GET_AUTH_USER_OK,
  payload: { response },
});

export const getAuthUserErr = (error: Error) => ({
  type: GET_AUTH_USER_ERR,
  payload: { error },
});

export const loginUser = (data: LoginUserRequest) => ({
  type: LOGIN_USER,
  payload: { data },
});

export const loginUserOk = (response: LoginUserResponse) => ({
  type: LOGIN_USER_OK,
  payload: { response },
});

export const loginUserErr = (error: Error) => ({
  type: LOGIN_USER_ERR,
  payload: { error },
});

export const saveReturnUrl = (url: string) => ({
  type: SAVE_RETURN_URL,
  payload: { url },
});

export const doLoginUserCleanup = () => ({
  type: DO_LOGIN_USER_CLEANUP,
});

export const logoutUser = (user: User) => ({
  type: LOGOUT_USER,
  payload: { user },
});

export const logoutUserOk = () => ({
  type: LOGOUT_USER_OK,
});

export const logoutUserErr = (error: Error) => ({
  type: LOGOUT_USER_ERR,
  payload: { error },
});

export const refreshAuthUser = () => ({
  type: REFRESH_AUTH_USER,
});

export const refreshAuthUserOk = (response: GetUserResponse) => ({
  type: REFRESH_AUTH_USER_OK,
  payload: { response },
});

export const refreshAuthUserErr = (error: Error) => ({
  type: REFRESH_AUTH_USER_ERR,
  payload: { error },
});

export const validateVerifCode = (data: ValidateVerifCodeRequest) => ({
  type: VALIDATE_VERIF_CODE,
  payload: { data },
});

export const validateVerifCodeOk = (response: ValidateVerifCodeResponse) => ({
  type: VALIDATE_VERIF_CODE_OK,
  payload: { response },
});

export const validateVerifCodeErr = (error: Error) => ({
  type: VALIDATE_VERIF_CODE_ERR,
  payload: { error },
});

export const resendVerifCode = () => ({
  type: RESEND_VERIF_CODE,
});

export const resendVerifCodeOk = (response: ResendVerifCodeResponse) => ({
  type: RESEND_VERIF_CODE_OK,
  payload: { response },
});

export const resendVerifCodeErr = (error: Error) => ({
  type: RESEND_VERIF_CODE_ERR,
  payload: { error },
});

export const doVerifCodeCleanup = () => ({
  type: DO_VERIF_CODE_CLEANUP,
});

export const loginWithAuth0 = (idToken: string) => ({
  type: LOGIN_WITH_AUTH0,
  payload: { idToken },
});

export const loginWithAuth0Ok = (response: LoginUserResponse) => ({
  type: LOGIN_WITH_AUTH0_OK,
  payload: { response },
});

export const loginWithAuth0Err = (error: Error) => ({
  type: LOGIN_WITH_AUTH0_ERR,
  payload: { error },
});